export { default } from '@/ui/Loader'
